<template>
  <div class="row no-wrap items-center">
    <r-radio :value="value" :val="val" dense :size="buttonSize" v-on="$listeners"/>
    <div :class="selectedClass" :style="labelStyle">
      <slot>
        <div>
          <span v-if="label">{{ label }}</span>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import RRadio from '@/components/base/RRadio';

export default {
  name: 'DefaultRadio',
  components: { RRadio },
  props: {
    val: {
      type: [String, Number, Boolean],
      required: true,
    },
    value: [String, Number, Boolean],
    label: String,
    fontSize: {
      type: String,
      default: '12px',
    },
    buttonSize: {
      type: String,
      default: 'lg',
    },
    disable: Boolean,
    dense: Boolean,
  },
  computed: {
    selectedClass() {
      if (this.val === this.value) {
        return ['text-riseup-blue', 'r-text-bold'];
      }
      return [];
    },
    labelStyle() {
      return {
        fontSize: this.size,
        marginRight: this.dense ? '5px' : '10px',
      };
    },

  },
};
</script>
